var map = {
	"./": 3741,
	"./adefault.module.scss": 4751,
	"./advanced/adefault.module.scss": 6271,
	"./advanced/advanced": 9990,
	"./advanced/advanced.js": 9990,
	"./advanced/crickettimes.module.scss": 4350,
	"./crickettimes.module.scss": 5979,
	"./index": 3741,
	"./index.js": 3741,
	"./superdeporte.module.scss": 8841,
	"./talksport.module.scss": 7303,
	"./thesun.module.scss": 9170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2603;